import styled from '@emotion/styled';

export const WarningMessage = styled.div`
    margin-bottom: ${({ theme }) => theme.spacing[4]};
    font-size: ${({ theme }) => theme.font.size.normal};
    font-family: ${({ theme }) => theme.font.family};
    font-weight: ${({ theme }) => theme.font.weight.regular};
    font-style: normal;
    color: ${({ theme }) => theme.color.bloodyMary};
    opacity: ${({ theme }) => theme.opacity.visible};
    white-space: pre-line;
`;

export const FlexContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${({ theme }) => theme.spacing[4]};
    font-family: ${({ theme }): string => theme.font.family};
    font-weight: ${({ theme }) => theme.font.weight.regular};
    font-size: ${({ theme }) => theme.font.size.small};
`;

export const LabelContainer = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[2]};
    & > span {
        margin-bottom: ${({ theme }) => theme.spacing[2]};
    }
`;

export const StyledInfoParagraph = styled.p`
    margin-top: ${({ theme }) => theme.spacing[2]};
    margin-left: ${({ theme }) => theme.spacing[1]};
    color: ${({ theme }) => theme.color.grey500};

    & > span {
        color: ${({ theme }) => theme.color.electricBlue};
        :hover {
            cursor: pointer;
        }
    }
`;
